import {UI} from "../../../stem-core/src/ui/UIBase.js";

import {Messages} from "../../Messages.js";
import {Theme} from "../../../stem-core/src/ui/style/Theme.js";
import {DONATE_PAGE_URLS} from "../PanelConstants.js";
import {PoweredByBlink} from "../PoweredByBlink.jsx";
import {StepDescription} from "./StepDescription.jsx";
import {authService, userService} from "../../../client/connection/Services.js";
import {LoadingSpinner} from "../../../core/ui/LoadingSpinner.jsx";
import {PaymentMethodStore} from "../../State.js";
import {iFrameMerchantService} from "../../services/IframeMerchantService.js";
import {iFrameUserDataService} from "../../services/IFrameUserDataService.js";
import {MessageElement} from "../../widget/ui/MessageElement.jsx";
import {AuthFlowPanel} from "../../website/unauthenticated/slides/AuthFlowPanel.jsx";


export function donatePageOnAuthenticate(element) {
    authService.onAuthenticationChange(() => {
        if (element.isInDocument() && authService.isAuthenticated()) {
            LoadingSpinner.show();
            userService.ensureUserDataRequested(() => {
                LoadingSpinner.hide();
                if (iFrameUserDataService.getActiveRecurringDonation()) {
                    element.options.changeURL(DONATE_PAGE_URLS.recurringDonor);
                } else if (!PaymentMethodStore.getPrimary()) {
                    element.options.changeURL(DONATE_PAGE_URLS.payWithAddedCard);
                } else {
                    element.options.changeURL(DONATE_PAGE_URLS.payWithChosenCard);
                }
            });
        }
    });
}


export class InlineAuthPanel extends UI.Element {
    render() {
        return [
            <StepDescription
                backFunction={() => this.options.changeURL(DONATE_PAGE_URLS.donate, true)}
                currentStep={2}
                stepDescription={Messages.authenticate}
            />,

            <MessageElement
                style={{
                    fontSize: Theme.props.MERCHANT_FONT_SIZE_LARGE,
                    textAlign: "center",
                    margin: "0 auto 18px"
                }}
                message={Messages.merchantUsesBlinkForDonations(iFrameMerchantService.getMerchant().name)}/>,

            <AuthFlowPanel showFooter={false} />,

            <PoweredByBlink />,
        ];
    }

    onMount() {
        donatePageOnAuthenticate(this);
    }
}
